import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaSlider from "../../../../../../components/common/BriaSlider/BriaSlider";
import { IMAGE_REFERENCE_CONFIGS } from "../../../../../../constants/TextToImageConstants";
import { useAppStore } from "../../../../../../hooks/useStores";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";

const TextToImageSteps = () => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.steps" });
	const { textToImageStore } = useAppStore();
	const { handleConfigChange } = textToImageStore;

	const {
		min,
		max,
		default: defaultSteps,
	} = IMAGE_REFERENCE_CONFIGS.steps[textToImageStore.config.fast ? "fast" : "not_fast"];

	useEffect(() => {
		handleConfigChange("steps_num", defaultSteps);
	}, [textToImageStore.config.fast]);

	return (
		<InputLayout label={t("label")} info={t("info")}>
			<BriaSlider
				value={textToImageStore.config.steps_num}
				onChange={(_, value) => handleConfigChange("steps_num", value as number)}
				step={1}
				min={min}
				max={max}
				valueLabelDisplay="auto"
				marks={[0, 0.25, 0.5, 0.75, 1].map((f) => {
					const value = min + Math.round((max - min) * f);
					return { value, label: String(value) };
				})}
			/>
		</InputLayout>
	);
};

export default observer(TextToImageSteps);
